import {
  MAIN_PAGE,
  SUCCESS_PAGE,
  SET_RESERVATION_ID
} from '../actions/constantsActions';

const initialState = {
  step: 1,
  reservationId: null
};

const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case MAIN_PAGE:
      return {
        ...state,
        step: 1
      };
    case SUCCESS_PAGE:
      return {
        ...state,
        step: 2
      };

    case SET_RESERVATION_ID:
      return {
        ...state,
        reservationId: action.id
      };

    default:
      return state;
  }
};

export default reportReducer;
